<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__advertoauth}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item>
          <w-date v-model="dateValue" @input="getTimes"></w-date>
        </el-form-item>
        <el-form-item>
          <renSelect
            v-model="dataForm.products"
            dictType="loan_type"
            originPage="put"
            placeholder="产品"
          ></renSelect>
        </el-form-item>
        <el-form-item>
          <wCity v-model="dataForm.city" defaultUrl="/sys/tschedule/accessToAccess" placeholder="城市"></wCity>
        </el-form-item>
   
        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
        <!--        <el-form-item>-->
        <!--          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>-->
        <!--        </el-form-item>-->
        <el-form-item>
          <el-button v-if="$hasPermission('sys:tschedule:save')" type="primary" @click="childHandle()">{{
            $t("add")
          }}</el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
        @sort-change="dataListSortChangeHandle($event,false)"
      >
        <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
        <el-table-column
          prop="companyName"
          label="公司"
          header-align="center"
          align="center"
        
        ></el-table-column>
        <el-table-column
          prop="productsName"
          label="产品"
          header-align="center"
          align="center"
          
        ></el-table-column>
        <el-table-column
          prop="city"
          label="城市"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="productPrice"
          label="定价(元/个)"
          header-align="center"
          align="center"
         
        ></el-table-column>
        <el-table-column prop="startDate" label="投放日期"  align="center" header-align="center" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.startDate + "~" + scope.row.endDate }}
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          label="投放时间段"
          width="300"
          header-align="center"
        >
          <template slot-scope="scope">
            <div v-html="returntext(scope.row, 1)"></div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="线索数量" header-align="center">
          <template slot-scope="scope">
            <div v-html="returntext(scope.row, 2)"></div>
          </template>
        </el-table-column>

        <el-table-column
          prop="createDate"
          label="录入时间"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="updateTime"
          label="修改时间"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          header-align="center"
          align="center"
          sortable="custom"
        >
        <template slot-scope="scope">
          {{ scope.row.status == 1 ? '有效' : '无效' }}
        </template>
      </el-table-column>

        <el-table-column
          :label="$t('handle')"
       
          header-align="center"
          align="center"
         
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="childHandle(scope.row.id)"
              v-if="$hasPermission('sys:tschedule:update')"
            >
              {{ $t("update") }}
            </el-button>
            <el-button
              type="text"
              size="small"
              v-if="$hasPermission('sys:tschedule:delete')"
              @click="deleteHandle(scope.row.id)"
              >{{ $t("delete") }}</el-button>
              <el-button
              type="text"
              size="small"
              v-if="$hasPermission('put:put:daylog')"
              @click="$router.push('/put-operatinglog?id='+scope.row.id)"
              >日志</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
    </div>
  </el-card>
</template>
  
  <script>
import mixinViewModule from "@/mixins/view-module";
import city from "../../../components/my-city/city.vue";
import wDate from "../../../components/w-search/search.vue";
import renSelect from "../../../components/ren-select";

export default {
  mixins: [mixinViewModule],
  data() {
    return {
      addOrUpdateVisible: false,
      url: "",
      dateValue: "",
      mixinViewModuleOptions: {
        getDataListURL: "/sys/tschedule/page",
        getDataListIsPage: true,
        exportURL: "/sys/tschedule/export",
        deleteURL: "/sys/tschedule",
        deleteIsBatch: true,
      },
      dataForm: {
        startDate: "",
        endDate: "",
        city: "",
        products: "",
      },
      cityList: [],
    };
  },

  watch: {
    $route(val) {
      console.log(val, "put");
      this.getDataList();
    },
  },
  mounted(){
    // this.getcity()
  },
  methods: {
    getTimes() {
      if (this.dateValue != null) {
        this.dataForm.startDate = this.dateValue[0];
        this.dataForm.endDate = this.dateValue[1];
      } else {
        this.dataForm.startDate = "";
        this.dataForm.endDate = "";
      }
    },

    returntext(row, n) {
      // console.log(row);
      let str = "";
      if (n == 1) {
        row.tscheduleDetailDTO.forEach((item) => {
          str += `${item.cycle}: ${item.detailedTime ? item.detailedTime : '无' }<br>`;
        });
      } else {
        row.tscheduleDetailDTO.forEach((item) => {
          str += `${item.cycle}: ${item.quantity}<br>`;
        });
      }

      return str;
    },
     // 获取city
     getcity() {
      this.$http.post("/sys/tschedule/accessToAccess").then(({ data: res }) => {
        if (res.code != 0) {
          this.$message.error(res.msg);
          return;
        }
        console.log(res)
        this.cityList = res.data?.join("")
          .split("|")
          .map((item) => {
            return {
              value: item,
              label: item,
            };
          });
        console.log(res.data.join("").split("|"));
      });
    },

    childHandle(id = '') {
      // 路由参数
      // console.log(id)
      // this.$router.push({
      //   path: "/put-put-plan"
      // });
      this.$router.push({
        path: "/put-put-plan?scopeCityId=" + id || "",
       
      });
      // const routeParams = {
      //     // routeName: `${this.$route.name}__${id || ''}`,
      //     routeName: 'putadd',
      // //   title: `${this.$route.meta.title} - ${row.pageName} - ${row.city}`,
      //   title: `_1`,
      //   path: 'put/put-plan',
      //   params: {
      //     scopeCityId: id || ''
      //   }
      // }
      // 动态路由
      // this.$bus.$emit("aaa", )
      // this.$nextTick(()=>{
      //     addDynamicRoute(routeParams, this.$router)
      // })
    },
  },

  components: {
    sclectCity: city,
    wDate,
    renSelect,
  },
};
</script>
  